webpackJsonp([1],{

/***/ "aMmw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("jYI/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Page__ = __webpack_require__("QYBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Content__ = __webpack_require__("FcPK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_actions_waitlistActions__ = __webpack_require__("mVfy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_icon_success_svg__ = __webpack_require__("Wjl/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_icon_success_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_icon_success_svg__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("div", { "class": "loading loading-lg" });

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "span",
  null,
  "You have been removed from the waitlist"
);

var WaitlistPass = function (_Component) {
  _inherits(WaitlistPass, _Component);

  function WaitlistPass() {
    _classCallCheck(this, WaitlistPass);

    return _possibleConstructorReturn(this, _Component.call(this));
  }

  WaitlistPass.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        pass = _props.pass,
        waitlistId = _props.waitlistId;

    pass(waitlistId);
  };

  WaitlistPass.prototype.render = function render() {
    var waitlist = this.props.waitlist;

    if (waitlist.pass.loading) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_2__components_Page__["a" /* default */],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          __WEBPACK_IMPORTED_MODULE_3__components_Content__["a" /* default */],
          { style: { padding: 30 } },
          _ref
        )
      );
    }

    var successStyle = {
      background: "url(" + __WEBPACK_IMPORTED_MODULE_5__assets_images_icon_success_svg___default.a + ") no-repeat center",
      backgroundSize: 160,
      color: "#1bab74",
      margin: "0px 12px",
      padding: "180px 0 4px 28px",
      textAlign: "center"
    };

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_2__components_Page__["a" /* default */],
      null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_3__components_Content__["a" /* default */],
        { style: { padding: 30 } },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "div",
          { style: successStyle },
          _ref2
        )
      )
    );
  };

  return WaitlistPass;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
  return { waitlist: state.waitlist };
}, {
  pass: __WEBPACK_IMPORTED_MODULE_4__state_actions_waitlistActions__["j" /* pass */]
})(WaitlistPass));

/***/ })

});


// WEBPACK FOOTER //
// 1.chunk.29d25.js